import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseDefaultListFilterComponent, QueryParameter } from 'yt-ng-framework';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { Router } from '@angular/router';
//import { baseDirectiveCreate } from '@angular/core/src/render3/instructions';

@Component({
    selector: 'epdv-filter-with-komitent',
    templateUrl: './epdv-filter-with-komitent.component.html'
})
export class FilterWithKomitentComponent extends BaseDefaultListFilterComponent {
    loadingEUInvoiceStatus:boolean = false;
    StatusDescription:string="";
    collapsed1:boolean=true;
    StatusRefreshTime:Date;
    @Output() RefreshStatusClicked = new EventEmitter();
    @Input() showStatusBox:boolean=false;

    constructor(protected datePipe: DatePipe
    ){
        super(datePipe);
    }

    selectedKomitent: string = 'Svi';

    ngOnInit(){
        this.SetInitParameters();
    }

    SelectKomitent(item: KomitentView){
        this.selectedKomitent = item != null ? item.Naziv + ', ' + item.Mesto : 'Svi';
    }
    
    SetFilterDescription(){
        super.SetFilterDescription();
        this.FilterDescription = 'Od: ' + this.GetPropertyValue(this.filterFormGroup.get('DateFrom').value, 'date') + 
                                 ', Do: ' + this.GetPropertyValue(this.filterFormGroup.get('DateTo').value, 'date') +
                                 ', Komitent: ' + this.selectedKomitent;
    }

    SetStatusDescription(){
        this.StatusDescription='Osveženo '
         +this.StatusRefreshTime.getHours().toString().padStart(2, "0")
          +":"+this.StatusRefreshTime.getMinutes().toString().padStart(2, "0")
          +":"+this.StatusRefreshTime.getSeconds().toString().padStart(2, "0")
         +' za dokumenta stara do '
         +this.filterFormGroup.get("DanaZaOsvezavanje").value.toString()
         +' dana.';
    }


    SetInitParameters(){
        super.SetInitParameters();
        let date = new Date();
        this.filterFormGroup = new FormGroup({
            DateFrom: new FormControl(new NgbDate(date.getFullYear(), 1, 1), [Validators.required]),
            DateTo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()), [Validators.required]),
            KomitentID: new FormControl()
            , DanaZaOsvezavanje: new FormControl(3)
        })
    }

    // RefreshStatusClick(id : number){
    RefreshStatusClick(){
        this.RefreshStatusClicked.emit(this.filterFormGroup.get("DanaZaOsvezavanje").value);
        this.StatusRefreshTime=new Date();
        this.SetStatusDescription();
        this.collapsed1=true;
    }

}